// FAQs.

function set_active_faq(hash) {
	if (hash) {
		// Set actives by URL anchor
		$j('.rm-faq-item__toggle[data-faq-hash="' + hash + '"]').attr('aria-expanded', 'true');
		$j('.rm-faq-item__content[data-faq-content-hash="' + hash + '"]').removeAttr('hidden');
	}
}

$j(function() {
	if ($j('.rm-faq-wrapper').length) {
		var hash = '';

		if (window.location.hash) {
			hash = window.location.hash.substring(1);
		}

		set_active_faq(hash);
	
		// FAQ Toggle.
		$j('.rm-faq-item__toggle').on('click', function(event) {
			event.preventDefault();

			var faq = $j(this).data('faq-slug');

			$j(this).attr('aria-expanded', function(index, attr){
				return attr == 'true' ? 'false' : 'true';
			});
			
			var new_active_faq = $j(this).closest('.rm-faq-wrapper').find('div[data-faq-content="' + faq + '"]');

			if (new_active_faq.attr('hidden')) {
				new_active_faq.removeAttr('hidden').focus();
			} else {
				new_active_faq.attr('hidden', '');
			}
		});
	}
});
